import { AUTH_PUBLIC_ERROR_CODES } from '@ruminati/errors/error-codes'
import ky from 'ky'

import { triggerLocalSessionChange, SESSION_CHANGE_REASONS } from '@/utilities/broadcaster'

export const BASE_URL = import.meta.env.VITE_APP_API_V2_BASE_URL ?? 'http://localhost:8081'

export const CommonApiV2Instance = ky.create({
  prefixUrl: BASE_URL,
  headers: {
    'content-type': 'application/json',
  },
  credentials: 'include',
  retry: {
    limit: 5,
    delay: () => 3000,
  },
  hooks: {
    afterResponse: [
      async (request, _options, response) => {
        if (response.status !== 401) return

        if (request.url.includes('/auth/login') || request.url.includes('/auth/register')) {
          return
        }

        try {
          const parsedResponse = await response.clone().json()
          if (typeof parsedResponse === 'object' && parsedResponse) {
            if ('code' in parsedResponse) {
              const responseCode = parsedResponse.code as string
              if (AUTH_PUBLIC_ERROR_CODES.includes(responseCode as never)) {
                triggerLocalSessionChange(SESSION_CHANGE_REASONS.SESSION_INVALID)
              }
            }
          }
        } catch {
          return
        }
      },
    ],
  },
})
